(function () {
  'use strict';

  var LS_KEY      = 'rv_products'; // shared with recently-viewed.liquid section
  var drawerReady = false;
  var cssInjected = false;
  var rvOpener    = null;

  function injectCSS() {
    if (cssInjected) return;
    var s = document.createElement('style');
    s.id = 'rv-drawer-styles';
    s.textContent = '.rv-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:900;opacity:0;visibility:hidden;transition:opacity .28s ease,visibility .28s ease}.rv-overlay.is-open{opacity:1;visibility:visible}.rv-drawer{position:fixed;top:0;right:0;bottom:80px;width:420px;max-width:100vw;background:#fff;z-index:901;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s cubic-bezier(.25,.46,.45,.94);box-shadow:-4px 0 40px rgba(0,0,0,.16);outline:none;border-radius:0 0 0 10px}.rv-drawer.is-open{transform:translateX(0)}.rv-drawer__header{display:flex;align-items:center;justify-content:space-between;padding:0 18px;height:58px;border-bottom:1px solid #e8e8e2;flex-shrink:0;background:#fff}.rv-drawer__title{display:flex;align-items:center;gap:8px;font-size:15px;font-weight:700;color:#111;letter-spacing:-.01em}.rv-close-btn{display:flex;align-items:center;justify-content:center;width:34px;height:34px;border:1px solid #e5e5e5;border-radius:50%;background:transparent;cursor:pointer;color:#666;transition:background .15s,color .15s;flex-shrink:0}.rv-close-btn:hover{background:#f5f5f5;color:#111}.rv-body{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}.rv-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 24px;text-align:center;min-height:100%}.rv-empty[hidden]{display:none!important}.rv-empty__icon{color:#d4d4d4;margin-bottom:18px}.rv-empty__msg{font-size:17px;font-weight:700;color:#111;margin:0 0 8px}.rv-empty__sub{font-size:13px;color:#9ca3af;margin:0;line-height:1.5}.rv-list{list-style:none;margin:0;padding:0}.rv-card{display:flex;align-items:flex-start;gap:12px;padding:14px;border-bottom:1px solid #f0f0ec;transition:background .12s;animation:rv-fade-in .2s ease forwards}.rv-card:last-child{border-bottom:none}.rv-card:hover{background:#fafaf8}@keyframes rv-fade-in{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}.rv-card__img-wrap{flex-shrink:0;width:82px;height:82px;border-radius:8px;overflow:hidden;border:1px solid #e8e8e2;background:#f5f5f3;display:block;text-decoration:none}.rv-card__img{width:100%;height:100%;object-fit:cover;display:block}.rv-card__img-ph{width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#d4d4d4}.rv-card__info{flex:1;min-width:0}.rv-card__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;font-weight:600;color:#111;text-decoration:none;line-height:1.4;margin-bottom:5px;display:block}.rv-card__title:hover{text-decoration:underline}.rv-card__price{display:flex;align-items:baseline;gap:6px}.rv-card__price-now{font-size:14px;font-weight:700;color:#111}.rv-card__price-now--sale{color:#dc2626}.rv-card__price-was{font-size:12px;color:#9ca3af;text-decoration:line-through}.rv-drawer__footer{padding:13px 14px;border-top:1px solid #e8e8e2;flex-shrink:0;text-align:center;background:#fff}.rv-clear-btn{font-size:12px;color:#9ca3af;background:none;border:none;cursor:pointer;text-decoration:underline;transition:color .15s;padding:0}.rv-clear-btn:hover{color:#dc2626}#rv-drawer [hidden]{display:none!important}@media(max-width:480px){.rv-drawer{width:100vw;bottom:0;border-radius:0}}';
    document.head.appendChild(s);
    cssInjected = true;
  }

  // ── Storage ───────────────────────────────────────────────────────────────
  function readList() {
    try {
      var raw  = localStorage.getItem(LS_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var c      = parseInt(cents, 10);
    var amount = (c / 100).toFixed(2);
    var fmt    = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt
      .replace(/\{\{amount\}\}/, amount)
      .replace(/\{\{amount_no_decimals\}\}/, Math.round(c / 100))
      .replace(/\{\{amount_with_comma_separator\}\}/, amount.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/, Math.round(c / 100));
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str || '');
    return d.innerHTML;
  }

  // ── Drawer element refs (assigned after lazy injection) ───────────────────
  var overlay, drawer, closeBtn, listEl, emptyEl, footerEl, clearAllBtn;

  // ── Lazy inject from <template> ───────────────────────────────────────────
  function injectDrawer() {
    if (drawerReady) return true;
    var tpl = document.getElementById('rv-drawer-template');
    if (!tpl) return false;
    document.body.appendChild(tpl.content.cloneNode(true));

    overlay     = document.getElementById('rv-overlay');
    drawer      = document.getElementById('rv-drawer');
    closeBtn    = document.getElementById('rv-close');
    listEl      = document.getElementById('rv-list');
    emptyEl     = document.getElementById('rv-empty');
    footerEl    = document.getElementById('rv-footer');
    clearAllBtn = document.getElementById('rv-clear-all');

    bindDrawerEvents();
    drawerReady = true;
    return true;
  }

  // ── Open / close ──────────────────────────────────────────────────────────
  function openDrawer() {
    injectCSS();
    if (!injectDrawer()) return;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    window.theme?.trapFocus(drawer, rvOpener);
    drawer.focus();
    render();
  }

  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.theme?.releaseFocus(drawer);
    rvOpener = null;
  }

  function bindDrawerEvents() {
    if (closeBtn)    closeBtn.addEventListener('click', closeDrawer);
    if (overlay)     overlay.addEventListener('click', closeDrawer);
    if (clearAllBtn) clearAllBtn.addEventListener('click', function () {
      try { localStorage.removeItem(LS_KEY); } catch (e) {}
      render();
    });
  }

  // ── Render list ───────────────────────────────────────────────────────────
  function render() {
    var list = readList().filter(function (p) { return p && p.id; });

    if (list.length === 0) {
      emptyEl.removeAttribute('hidden');
      listEl.innerHTML = '';
      if (footerEl) footerEl.setAttribute('hidden', '');
      return;
    }

    emptyEl.setAttribute('hidden', '');
    if (footerEl) footerEl.removeAttribute('hidden');

    listEl.innerHTML = list.map(function (p) {
      var onSale      = p.compare_price && p.compare_price > p.price;
      var compareHtml = onSale
        ? '<span class="rv-card__price-was">' + formatMoney(p.compare_price) + '</span>'
        : '';
      var imgHtml = p.image
        ? '<img class="rv-card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="82" height="82">'
        : '<div class="rv-card__img-ph"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

      return (
        '<li class="rv-card" data-rv-id="' + esc(p.id) + '">' +
          '<a class="rv-card__img-wrap" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
          '<div class="rv-card__info">' +
            '<a class="rv-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="rv-card__price">' +
              '<span class="rv-card__price-now' + (onSale ? ' rv-card__price-now--sale' : '') + '">' + formatMoney(p.price) + '</span>' +
              compareHtml +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');

    verifyLinks(list);
  }

  // ── Self-healing: prune entries whose product URL no longer resolves
  // (deleted/unpublished product, or — the original reason this was added —
  // stale localStorage left over from browsing a different store on the
  // same browser profile). A HEAD request is cheap and only runs for the
  // handful of items actually visible when the drawer is opened, never on
  // page load. Only prunes on a confirmed 4xx/5xx response; network errors
  // (e.g. offline) are left alone so items aren't removed just because the
  // check itself failed. ──────────────────────────────────────────────────
  function verifyLinks(list) {
    list.forEach(function (p) {
      if (!p.url) return;
      fetch(p.url, { method: 'HEAD' })
        .then(function (res) {
          if (!res.ok) pruneStaleEntry(p.id);
        })
        .catch(function () {});
    });
  }

  function pruneStaleEntry(id) {
    var remaining = readList().filter(function (p) { return p.id !== id; });
    try { localStorage.setItem(LS_KEY, JSON.stringify(remaining)); } catch (e) {}

    var card = listEl && listEl.querySelector('[data-rv-id="' + id + '"]');
    if (!card) return;
    card.style.transition = 'opacity .2s ease';
    card.style.opacity = '0';
    setTimeout(function () {
      card.remove();
      if (listEl && !listEl.children.length) render();
    }, 200);
  }

  // ── Global open trigger ───────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-rv-open]');
    if (!opener) return;
    e.preventDefault();
    rvOpener = opener;
    openDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
